// extracted by mini-css-extract-plugin
module.exports = {"star":"Star_star__bnZ7W","stretchBounce":"Star_stretchBounce__GxXmm"};